export const CAREER_START = new Date(2017, 4, 1);

export function getExperienceDuration(asOf = new Date(), start = CAREER_START) {
  const startMonth = new Date(start.getFullYear(), start.getMonth(), 1);
  const endMonth = new Date(asOf.getFullYear(), asOf.getMonth(), 1);
  const totalMonths = Math.max(
    0,
    (endMonth.getFullYear() - startMonth.getFullYear()) * 12 +
      (endMonth.getMonth() - startMonth.getMonth())
  );

  return {
    totalMonths,
    years: Math.floor(totalMonths / 12),
    months: totalMonths % 12,
  };
}

export function formatExperience(duration, compact = false) {
  const yearLabel = compact ? "yrs" : duration.years === 1 ? "year" : "years";
  const monthLabel = compact ? "mos" : duration.months === 1 ? "month" : "months";
  return `${duration.years} ${yearLabel} ${duration.months} ${monthLabel}`;
}
